import React from "react";
import "./isfReferenceDateHint.scss";

export default function IsfReferenceDateHint({
  text = "Baseline date for calculating document due dates.",
}) {
  return (
    <small className="isf-reference-date-hint">
      <i className="fa fa-info-circle" aria-hidden="true" />
      <span>{text}</span>
    </small>
  );
}
